import { ELocalesForSupportedLanguages, TSupportedLanguages } from '@monorepo/types';

export const LocalisationUtils = {
  getLocaleForDateStringFromSelectedLanguage(selectedLanguage: TSupportedLanguages) {
    switch (selectedLanguage) {
      case 'en':
        return ELocalesForSupportedLanguages.ENGLISH_US;
      case 'vi':
        return ELocalesForSupportedLanguages.VIETNAMESE;
      case 'id':
        return ELocalesForSupportedLanguages.INDONESIAN;
      case 'hi':
        return ELocalesForSupportedLanguages.HINDI;
      default:
        return ELocalesForSupportedLanguages.ENGLISH_US;
    }
  },
};
